// extracted by mini-css-extract-plugin
export default {"container":"EndUserLicenseAgreement_container__buYs8"};